import React, { useState, useEffect } from 'react'
import logger from '../../../utils/logger'
import { MemberService } from '../../../services/MemberService'
import { toast } from 'react-toastify'



export const CustomAlert = ({ content, toggleModal, handleObject, customObjet }) => {


    const actionToast = (text, type) => {

        toast.success(text, {
            autoClose: 2000
        })

    }

    const errorToast = (text) => {
        toast.error(text, {
            autoClose: 2000
        })
    }



    const [initialObj, setInitialObj] = useState({})

    useEffect(() => {


        const enrollmentId = async () => {
            try {
                const response = await MemberService.getMemberEnrollment(content?.email)
                logger.warn('HAY RESPONSE: ', response)


                const tpaTrainingObj = response?.data?.find(e => e.typeId == 2)

                logger.debug('tpaTrainingObj: ', tpaTrainingObj)

                const customEnrollmentId = (content.url === 'TPATraining')
                    ? tpaTrainingObj?.id
                    : response?.data?.[0]?.id

                const preObject = {

                    deliveryId: content.id,
                    enrollmentId: customEnrollmentId,
                    email: content?.email,
                    // memberId: content?.activeEnrollment?.memberId
                    memberId: response?.data[0]?.memberId
                }

                logger.debug('preObject: ', preObject)

                const newObject = Object.keys(content.body).reduce((acc, key) => {

                    if (key in preObject && preObject[key] != null) {
                        acc[key] = preObject[key]
                    }
                    return acc;
                }, {})

                logger.debug('newObject: ', newObject)

                setInitialObj(newObject)


            }
            catch (error) {
                logger.error('error al obtener member enrollment', error);
                errorToast()
            }
        }

        enrollmentId()

    }, [content])

    logger.warn('content: ', content)
    logger.warn('initialObj: ', initialObj)

    logger.debug('Se enviaran estos parametros: ', initialObj)

    const performAction = async () => {
        try {
            // if (!initialObj || !content?.apiAction?.param) return
            // const response = await MemberService.dinamicEnrollmentAction(
            //     content.urlTarget.init,
            //     content.urlSegment == "Delivery" ? content : initialObj,
            //     content.urlSegment)

            const response = await MemberService.dinamicEnrollmentAction(
                content.urlTarget.getInit(initialObj),
                initialObj,
                content.urlTarget.type
            )


            logger.warn('performAction: ', response)

            if (response.status === 200) {

                if (customObjet) {
                    handleObject(customObjet)
                } else {
                    handleObject({
                        PageSize: 10,
                        PageIndex: 1
                    })
                }
                actionToast(response.data?.message)
            }
        } catch (error) {
            logger.warn('error en dinamic enrollment action', error);

            if (error.response.status === 403) {
                errorToast('No tienes permiso para ejecutar esta acción')

                return
            }

            errorToast(error.response?.data?.message)

        }
    }


    return (

        <div className="modal-content contentWidhtRenovation">

            <div className="modal-body mbodyR-class">

                <div className="spanE-container">
                    <span className="material-symbols-outlined formation-alert-icon-error">error</span>
                </div>



                <p className="renovation-title">
                    {content.title}
                </p>

                <p className="renovation-text">
                    ¿Estás seguro de que deseas <b>{content.verb}</b> a <b>{content.email}</b>?
                </p>

                <div className="btns-cancel-renovation">

                    <button
                        className="btn-sr btn-sr-width btn btn-success"
                        id="saveButton"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                            performAction()
                            toggleModal()
                        }}
                    >Si, {content.btnTitle}</button>


                    <button className="btn-cancel btn-sr-cancel" data-bs-dismiss="modal"
                        aria-label="Close" id="cancelButton" onClick={toggleModal}>Cancelar</button>

                </div>

            </div>
        </div>



    )
}
